export default "__VITE_ASSET__CsQY2_nC__"